export default "/mendel-signature.png";